import React, { useEffect, useState } from 'react';
import FooterBlue from '../../components/FooterBlue';
import '@fontsource/oswald';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/axiosInstance';
import HeaderBlue from '../../components/HeaderBlue';

const Pricing = () => {
    const navigate = useNavigate();
    const [packages, setPackages] = useState([]);

    const [specialPackage, setSpecialPackage] = useState(null);

    useEffect(() => {
        const fetchPackages = async () => {
            try {
                const res = await api.get('/packages/active');
                console.log(res, ' res');
                if (Array.isArray(res.data)) {
                    // const standardPackage = res.data.filter((pkg) => pkg.name === 'Standard Package');
                    if (Array.isArray(res.data)) {
                        const sortedPackages = res.data.sort((a, b) => a.price - b.price);
                        setPackages(sortedPackages);
                    }
                }
            } catch (err) {
                console.error('Failed to fetch packages:', err);
            }
        };

        fetchPackages();

        //fetch the special package alongside regular packages
        const fetchSpecialPackage = async () => {
            try {
                const res = await api.get('/special-package/details');

                if (res.data.success) {
                    setSpecialPackage(res.data.package);
                }
            } catch (err) {
                console.error('Could not load special package:', err);
            }
        };

        fetchSpecialPackage();
    }, []);

    return (
        <div className='flex flex-col min-h-screen bg-gray-100 text-gray-900'>
            <HeaderBlue />

            <section
                className='w-full pt-32 pb-20 px-4 md:py-40 xl:py-60 relative bg-cover bg-top'
                style={{
                    backgroundImage: "url('assets/pacakgesbanner.webp')",
                }}
            >
                <div className='absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0'></div>
                <div className='md:px-40 relative z-10'>
                    <h2 className='text-white text-4xl  md:text-6xl font-oswald drop-shadow-lg mb-5'>
                        CARRIER PACKAGES
                    </h2>
                    <p className='text-white text-base md:text-xl interfont font-oswald'>
                        {' '}
                        Choose the perfect plan to connect with top truck drivers
                        <br />
                        and grow your team efficiently nationwide.
                    </p>
                </div>
            </section>
            {/* Dynamic Packages Section */}
            <section className='text-black px-4 md:px-20 py-20 bg-blue-100'>
                <div className='max-w-6xl mx-auto'>
                    <div className='grid grid-cols-1 gap-16 items-center'>
                        {/* Left column: Heading & Subtext */}
                        <div className='text-center md:text-left col-span-3'>
                            <h2
                                className='text-3xl  mb-4 interfont text-gray-700 '
                                style={{ fontSize: 50, lineHeight: 1 }}
                            >
                                We only provide <br />
                                <b className='text-black' style={{ marginTop: '12px', display: 'inline-block' }}>
                                    THE BEST PRICING.
                                </b>
                            </h2>
                            <p className='text-lg  mt-10 '>
                                Pick your perfect plan with no hidden charges or surprise fees. Our packages are
                                designed to give carriers flexibility, efficiency, and real value. Whether you’re just
                                starting or scaling your operations, we’ve got a plan that fits your needs.
                            </p>
                            <p className='italic text-gray-600 mt-5'>
                                Start building your driver network today with our Standard Package.
                            </p>
                            <div className='my-4'>
                                <div className='textiblack font-medium staffx  text-xl cursor-pointer mb-10'>
                                    Why Choose This Package?
                                </div>
                                <ul className='space-y-3 text-gray-700'>
                                    <li className='flex items-start gap-2'>
                                        <span className='text-blue-500 text-lg'>✔</span>
                                        <span>
                                            Affordable & Reliable – A cost-effective solution for carriers who want
                                            dependable driver access without overspending.
                                        </span>
                                    </li>
                                    <li className='flex items-start gap-2'>
                                        <span className='text-blue-500 text-lg'>✔</span>
                                        <span>
                                            Time-Saving – No need to spend weeks searching; we connect you with drivers
                                            faster.
                                        </span>
                                    </li>
                                    <li className='flex items-start gap-2'>
                                        <span className='text-blue-500 text-lg'>✔</span>
                                        <span>
                                            Flexible Usage – Perfect for companies that need to scale recruitment
                                            efforts without committing to long-term contracts.
                                        </span>
                                    </li>
                                    <li className='flex items-start gap-2'>
                                        <span className='text-blue-500 text-lg'>✔</span>
                                        <span>
                                            Seamless Support – Our team is always available to help you make the most of
                                            your plan.
                                        </span>
                                    </li>
                                </ul>
                            </div>

                            {/* <div className="textiblack font-medium staffx  text-lg cursor-pointer">
                                Payment Terms
                            </div> */}
                        </div>
                        {/* Right column: Packages */}
                        <div className='w-full flex justify-center col-span-3'>
                            <div className='flex flex-col md:flex-row gap-8 row-gap-[87px] justify-center items-stretch flex-wrap'>
                                {packages?.map((pkg) => {
                                    const isStarter = pkg.name === 'Starter Package';

                                    const accentGradient = isStarter
                                        ? 'linear-gradient(135deg, rgb(140, 200, 255), rgb(60, 155, 249))'
                                        : 'linear-gradient(135deg, #3c9bf9, #1e3a8a)';
                                    return (
                                        <div
                                            key={pkg._id}
                                            className='flex-1 max-w-md relative bg-white shadow-xl rounded-xl flex flex-col font-sans transition-transform hover:scale-[1.03] duration-300'
                                            style={{ overflow: 'visible' }}
                                        >
                                            {/* <div
                                        key={pkg._id}
                                        className='flex-1 max-w-md relative bg-white shadow-xl rounded-xl flex flex-col font-sans transition-transform hover:scale-[1.03] duration-300'
                                        style={{ overflow: 'visible' }}
                                    > */}
                                            {/* Big Price Circle */}
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '-50px',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    width: 110,
                                                    height: 110,
                                                    // background: 'linear-gradient(135deg, #3c9bf9, #1e3a8a)',
                                                    background: accentGradient,
                                                    borderRadius: '50%',
                                                    color: 'white',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '2.6rem',
                                                    fontWeight: '800',
                                                    // boxShadow: '0 10px 30px rgba(60, 155, 249, 0.45)',
                                                    boxShadow: isStarter
                                                        ? '0 10px 30px rgba(140, 200, 255, 0.45)'
                                                        : '0 10px 30px rgba(60, 155, 249, 0.45)',
                                                    userSelect: 'none',
                                                    zIndex: 10,
                                                    letterSpacing: '-0.03em',
                                                }}
                                            >
                                                ${pkg.price}
                                            </div>

                                            {/* Content Container */}
                                            <div
                                                className='pt-24 px-8 pb-8 text-center'
                                                style={{ color: 'black' /* dark blue */ }}
                                            >
                                                <h2
                                                    style={{
                                                        fontSize: '1.75rem',
                                                        fontWeight: '700',
                                                        marginBottom: '0.75rem',
                                                        letterSpacing: '0.03em',
                                                    }}
                                                >
                                                    {pkg.name}
                                                </h2>
                                                <button
                                                    onClick={() => navigate(`/package-details/${pkg._id}`)}
                                                    className='mt-5 px-8 py-3 rounded-full bg-blue-600 text-white font-semibold hover:bg-blue-700 shadow-md transition'
                                                    style={{
                                                        cursor: 'pointer',
                                                        //  background: 'rgb(60, 155, 249)'
                                                        background: accentGradient,
                                                    }}
                                                >
                                                    VIEW PACKAGE!
                                                </button>
                                                <h3
                                                    style={{
                                                        fontSize: '1.2rem',
                                                        fontWeight: '700',
                                                        marginTop: '24px',
                                                        marginBottom: '12px',
                                                        color: '#3c9bf9', // blue-600
                                                        letterSpacing: '0.02em',
                                                    }}
                                                >
                                                    Package Benefits
                                                </h3>
                                                <ul
                                                    style={{
                                                        listStyle: 'none',
                                                        paddingLeft: 0,
                                                        color: '#334155', // slate-700
                                                        fontSize: '1rem',
                                                        lineHeight: 1.7,
                                                        maxHeight: 180,
                                                        overflowY: 'auto',
                                                    }}
                                                >
                                                    {pkg.features.map((feat, i) => (
                                                        <li key={i} className='flex items-center mb-2'>
                                                            <i className='fas fa-check-circle text-blue-500 mr-3'></i>{' '}
                                                            {feat}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    );
                                })}

                                {/* SPECIAL DRIVER PACKAGE CARD */}
                                {specialPackage && (
                                    <div className='flex-1 max-w-md relative z-10 rounded-xl bg-white shadow-xl font-sans transition-transform duration-300 hover:scale-[1.03] overflow-visible flex flex-col'>
                                        {/* ★ SPECIAL Ribbon */}
                                        <div className='absolute top-4 -right-2 z-20 rounded px-2 py-1 text-[0.55rem] font-extrabold uppercase tracking-[0.1em] text-black shadow-md bg-gradient-to-br from-[#d4af37] to-[#f5e27a]'>
                                            ★ Premium Special
                                        </div>

                                        {/* Price Circle */}
                                        <div className='absolute -top-[50px] left-1/2 z-10 flex h-[110px] w-[110px] -translate-x-1/2 items-center justify-center rounded-full bg-gradient-to-br from-[#d4af37] to-[#92700a] text-[2.6rem] font-extrabold text-white shadow-[0_10px_30px_rgba(212,175,55,0.5)] tracking-[-0.03em] select-none'>
                                            ${specialPackage.price}
                                        </div>

                                        {/* Content */}
                                        <div className='pt-24 px-8 pb-8 text-center text-black'>
                                            {/* Package Name */}
                                            <h2 className='mb-3 text-[1.75rem] font-bold tracking-[0.03em]'>
                                                {specialPackage.name}
                                            </h2>

                                            {/* Button */}
                                            <button
                                                onClick={() => navigate('/special-package')}
                                                className='mt-5 cursor-pointer rounded-full bg-gradient-to-br from-[#d4af37] to-[#92700a] px-8 py-3 font-semibold text-white shadow-md transition hover:opacity-90'
                                            >
                                                VIEW PACKAGE!
                                            </button>

                                            {/* Heading */}
                                            <h3 className='mt-6 mb-3 text-[1.2rem] font-bold tracking-[0.02em] text-[#3c9bf9]'>
                                                Package Benefits
                                            </h3>

                                            {/* Features */}
                                            <ul className='max-h-[180px] overflow-y-auto text-base leading-7 text-slate-700 list-none pl-0 text-left'>
                                                {specialPackage.features.map((feat, i) => (
                                                    <li key={i} className='mb-2 flex items-center'>
                                                        <i className='fas fa-check-circle mr-3 text-blue-500'></i>
                                                        {feat}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}

                                {/* SPECIAL PACKAGE CARD ══ */}
                            </div>
                        </div>
                        {/* <div className='col-span-3'>
                            <div className='textiblack font-medium staffx  text-xl cursor-pointer mb-10'>
                                Why Choose This Package?
                            </div>
                            <ul className='space-y-3 text-gray-700'>
                                <li className='flex items-start gap-2'>
                                    <span className='text-blue-500 text-lg'>✔</span>
                                    <span>
                                        Affordable & Reliable – A cost-effective solution for carriers who want
                                        dependable driver access without overspending.
                                    </span>
                                </li>
                                <li className='flex items-start gap-2'>
                                    <span className='text-blue-500 text-lg'>✔</span>
                                    <span>
                                        Time-Saving – No need to spend weeks searching; we connect you with drivers
                                        faster.
                                    </span>
                                </li>
                                <li className='flex items-start gap-2'>
                                    <span className='text-blue-500 text-lg'>✔</span>
                                    <span>
                                        Flexible Usage – Perfect for companies that need to scale recruitment efforts
                                        without committing to long-term contracts.
                                    </span>
                                </li>
                                <li className='flex items-start gap-2'>
                                    <span className='text-blue-500 text-lg'>✔</span>
                                    <span>
                                        Seamless Support – Our team is always available to help you make the most of
                                        your plan.
                                    </span>
                                </li>
                            </ul>
                        </div> */}
                    </div>
                </div>
            </section>

            {/* Static Testimonial Section */}
            <div className='grid grid-cols-1 md:grid-cols-3 px-4 md:px-40 py-20 mt-10 bg-gray-200'>
                <div className='flex justify-center md:justify-start'>
                    <img
                        src='./assets/reviewer.webp'
                        alt='Reviewer'
                        className='rounded-full shadow-xl w-32 h-32 md:w-auto md:h-auto'
                    />
                </div>
                <div className='text-left p-5 md:p-20 col-span-2'>
                    <div className='text-6xl bluetext1 -mb-10 font-bold'>"</div>
                    <h3 className='staffx text-3xl md:text-4xl pl-5'>
                        We genuinely refer this platform as a classic one for connecting carriers to businesses.
                    </h3>
                    <h5 className='staffx text-2xl bluetext1 pl-5 underline mt-4'>Jake M</h5>
                    <h5 className='text-lg bluetext1 pl-5'>Logistics Director at SwiftHaul Inc.</h5>
                </div>
            </div>

            <FooterBlue />
        </div>
    );
};

export default Pricing;
